<template>
    <div>
      <v-container>
        <v-row
          justify="center"
          v-if="
            (!this.currentUser.facebookToken &&
              !this.$store.state.loggedIntoFacebook) ||
            (this.currentUser.facebookToken &&
              !this.$store.state.loggedIntoFacebook)
          "
        >
          <v-col cols="12" class="text-center">
            <h2 class="compeatfont">Welcome to Compeat</h2>
            <p>Please sign in to Facebook</p>
            <v-btn
              small
              rounded
              @click="loginWithFacebook()"
              class="primary"
              :loading="facebookLoginLoading"
            >
              <v-icon>mdi-facebook</v-icon> Login To Facebook
            </v-btn>
            <p v-if="cancelledLogin">
              Client Cancelled Signin. please try again.
            </p>
          </v-col>
          <v-col cols="12" class="text-center">
                  <v-btn 
                    @click="privacyPolicy('https://compeat.social/privacy-policy/')"
                    rounded 
                    small 
                    text 
                    color="pink"
                    class="black--text">
                    Privacy Policy
                  </v-btn>
                </v-col>
          <!-- <v-col cols="3">
            <v-card>
              <v-card-text>
                block 1
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card>
              <v-card-text>
                block 2
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card>
              <v-card-text>
                block 3
              </v-card-text>
            </v-card>
          </v-col>
            <v-col cols="3">
              <v-card>
                <v-card-text>
                  block 3
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card>
                <v-card-text>
                  block 3
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card>
                <v-card-text>
                  block 3
                </v-card-text>
              </v-card>
            </v-col> -->

        </v-row>
        <v-row
          v-if="
            this.currentUser.facebookToken && this.$store.state.loggedIntoFacebook
          "
        >
          <v-col cols="12" sm="12" md="6" lg="6">
            <h2 class="compeatfont">Welcome {{ user.name }}</h2>
          </v-col>
          <v-col cols="6" class="text-right hidden-sm-and-down">
            <v-btn
              small
              rounded
              @click="logoutFromFacebook()"
              class="primary ml-1"
              :loading="facebookLoginLoading"
            >
              <v-icon small class="mr-1">mdi-facebook</v-icon> Logout Facebook
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-tabs rounded v-model="tab" class="white">
              <v-tab :key="0">Plans Overview</v-tab>
              <v-tab :key="1">Account Overview</v-tab>
              <v-tab :key="2">Profile Overview</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item :key="0">
                <v-card v-if="!overlay" flat class="py-3 px-3">
                  <v-card-text class="pt-0">
                    <v-row justify="center" align="center">
                        <v-col cols="12">
                           <subscriptionTabs :allAgencySubscriptions="allAgencySubscriptions" :agency="this.agencyProfile"/>
                        </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-skeleton-loader
                  v-else
                  height="372px"
                  class="mx-auto"
                  type="table-heading, table-thead, table-tbody, table-tfoot"
                >
                </v-skeleton-loader>
              </v-tab-item>

              <v-tab-item :key="1">
                <v-card v-if="!overlay" flat class="py-3 px-3">
                  <v-card-text class="pt-0 px-0">
                    <v-row justify="center" align="center">
                        <v-col cols="12">
                            <subscriberAccount :allAgencySubscriptions="allAgencySubscriptions" />
                        </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-skeleton-loader
                  v-else
                  height="372px"
                  class="mx-auto"
                  type="table-heading, table-thead, table-tbody, table-tfoot"
                >
                </v-skeleton-loader>
              </v-tab-item>

              <v-tab-item :key="2">
                <v-card v-if="!overlay" flat class="py-3 px-3">
                  <v-card-text class="pt-0">
                    <v-row justify="center" align="center">
                        <v-col cols="12">
                            <subscriberProfile :user="currentUser" :agencyProfile="agencyProfile"/>
                        </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-skeleton-loader
                  v-else
                  height="372px"
                  class="mx-auto"
                  type="table-heading, table-thead, table-tbody, table-tfoot"
                >
                </v-skeleton-loader>
              </v-tab-item>
              </v-tabs-items>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>
  
  <script>
  import { firebaseApp } from "../../firebaseConfig";
  import {
    getFirestore,
    doc,
    getDoc,
    query,
    collection,
    where,
    getDocs,
    updateDoc,
  } from "firebase/firestore";
  import { getFunctions, httpsCallable } from "firebase/functions";
  const db = getFirestore(firebaseApp);
  import subscriptionTabs from '../subscribercomponents/subscriptionTabs.vue'
  import subscriberAccount from "../subscribercomponents/subscriberAccount.vue";
  import subscriberProfile from "../subscribercomponents/subscriberProfile.vue";
  
  import moment from "moment-timezone";
  
  export default {
    components:{
        subscriptionTabs,
        subscriberAccount,
        subscriberProfile
    },
    props: ["uid", "user", "getcurrentuser"],
    data: () => ({
      //loading varibles
      overlay: false,
  
      //user Info
      userToken: "",
      currentUser: {},
  
      //user cancels facebook login
      facebookLoginLoading: false,
      cancelledLogin: false,
  
      //agency info
      agencyProfile: [],
  
      //table varibles
      agencyActiveSubscriptions: [],
      agencyInactiveSubscriptions: [],
      agencyPausedSubscriptions:[],
      subscriptionDemos:[],
      search: "",
      headers: [
        { text: "Client", value: "name", sortable: false, align: "center" },
        {
          text: "Company",
          sortable: false,
          value: "package.primaryPage.name",
          align: "center",
        },
        { text: "Package", sortable: false, value: "package", align: "center" },
        {
          text: "Date Created",
          value: "dateCreated",
          sortable: true,
          align: "center",
        },
        { text: "Status", value: "isActive", sortable: false, align: "center" },
        { text: "Action", value: "action", sortable: false, align: "center" },
      ],
      tableLoading: false,
  
      tab: null,
      mainTabs:null,
      allAgencySubscriptions:[]
    }),
    //Created Hook - gets the user and checks for facebook userToken
    created() {
      this.overlay = true;
      this.currentUser = this.$store.state.user;
      if (this.currentUser.facebookToken) {
        this.checkTokenValid(this.currentUser.facebookToken);
      } else {
        this.overlay = false;
      }
    },
    //facebook SDK
    mounted() {
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
  
      window.fbAsyncInit = function () {
        FB.init({
          appId: "736605293879783",
          autoLogAppEvents: true,
          xfbml: true,
          version: "v16.0",
        });
      };
    },
    methods: {
      //Validates the user token
      checkTokenValid(token) {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const checkIfTokenIsValid = httpsCallable(
          functions,
          "checkIfTokenIsValid"
        );
        checkIfTokenIsValid({
          token: token,
        })
          .then((result) => {
            if (result.data.response.valid) {
              this.$store.commit("setloggedIntoFacebook", true);

              if(this.currentUser.package == 'No Package' || !this.currentUser.package){
                this.getAgencyInfo();
              }else if(this.currentUser.package == 'package-1-trial') {
                this.$router.push({
                  name: "createSingleSubscription",
                  params: {
                    title: "package-1-trial",
                  },
                });
              } else if(this.currentUser.package == 'package-2-trial') {
                this.$router.push({
                  name: "createSingleSubscription",
                  params: {
                    title: "package-2-trial",
                  },
                });
              } else if(this.currentUser.package == 'package-3-trial') {
                this.$router.push({
                  name: "createSingleSubscription",
                  params: {
                    title: "package-3-trial",
                  },
                });
              }

              // this.getAgencyInfo();
              // this.getAllSubscriptionData()
            }
          })
          .catch((err) => {
            this.$store.commit("setloggedIntoFacebook", false);
            this.overlay = false;
          });
      },
      //Logs user in with facebook SDK
      loginWithFacebook() {
        this.facebookLoginLoading = true;
        //incase user did cancel the login process
        this.cancelledLogin = false;
        FB.login(
          (response) => {
            if (response.authResponse) {
              this.userToken = response.authResponse.accessToken;
              this.extendUserFacebookToken();
            } else {
              this.cancelledLogin = true;
              this.facebookLoginLoading = false
              this.overlay = false;
              console.log("Cancelled login or did not fully authorize");
            }
          },
          {
            scope:
              "read_insights, pages_show_list, ads_management, ads_read, page_events, pages_read_engagement, pages_read_user_content, public_profile, instagram_basic, instagram_manage_insights",
          }
        );
      },
      //Extends the userToken of client once logged in
      async extendUserFacebookToken() {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const extendAccessToken = httpsCallable(functions, "extendAccessToken");
  
        extendAccessToken({
          token: this.userToken,
        }).then((result) => {
          this.updateUserFacebookToken(result.data.response);
        });
      },
      //Updates the user in firebase with the extended Token
      async updateUserFacebookToken(result) {
        const ref = doc(db, "users", this.currentUser.id);
        await updateDoc(ref, {
          facebookToken: result,
        });
  
        const ref2 = doc(db, "users", this.currentUser.id);
        const userUpdated = await getDoc(ref2);
  
        this.$store.commit("setUser", userUpdated.data());
        this.currentUser = userUpdated.data();
  
        this.facebookLoginLoading = false;
        this.checkTokenValid(this.currentUser.facebookToken);
      },
      //Logs out user using facebook SDK and clears the facebook userToken ine firebase
      logoutFromFacebook() {
        this.facebookLoginLoading = true;
        const functions = getFunctions(firebaseApp, "europe-west2");
        const facebookLogoutUser = httpsCallable(functions, "facebookLogoutUser");
  
        facebookLogoutUser({
          userId: this.currentUser.id,
        })
          .then((result) => {
            this.$store.commit("setloggedIntoFacebook", false);
            this.$store.commit("setUserFacebookToken", false);
            FB.getLoginStatus(function (response) {
              if (response.status === "connected") {
                var accessToken = response.authResponse.accessToken;
                FB.logout(
                  function (response) {
                    console.log(response);
                  },
                  { access_token: accessToken }
                );
              }
            });
            this.facebookLoginLoading = false;
          })
          .catch((err) => {
            console.log("Error Signing user out", err);
            this.facebookLoginLoading = false;
          });
      },
      //Gets agency info if client has been cleared with facebook verification
      async getAgencyInfo() {
        try {
          const docRef = doc(db, "agencies", this.currentUser.agencyId);
          const docSnap = await getDoc(docRef);
  
          if (docSnap.exists()) {
            this.agencyProfile = docSnap.data();
            this.$store.commit("setAgency", this.agencyProfile);
            this.overlay = false;
            this.getAllSubscriptionData();
          } else {
            console.log("No such document!");
            this.overlay = false;
          }
        } catch (err) {
          console.log("getAgencyInfo err", err);
          this.overlay = false;
        }
      },
      getAllSubscriptionData(){
        this.overlay = true
        const functions = getFunctions(firebaseApp, "europe-west2");
        const getAllSubscriptions = httpsCallable(
          functions,
          "getAllSubscriptions"
        );
        getAllSubscriptions({
          subscriberId: this.$store.state.user.id,
        })
          .then((result) => {
            console.log('paypalSubscription', result.data.response)
            this.agencyActiveSubscriptions = result.data.response.subscriptionActivePaypalData
            this.agencyInactiveSubscriptions = result.data.response.subscriptionCancelPaypalData
            this.agencyPausedSubscriptions = result.data.response.subscriptionPausePaypalData
            this.subscriptionDemos = result.data.response.subscriptionDemos
            // Merge the arrays
            const mergedSubscriptions = this.agencyActiveSubscriptions
                .concat(this.agencyInactiveSubscriptions, this.agencyPausedSubscriptions, this.subscriptionDemos);

            // If you want to ensure uniqueness in the merged array, you can use a Set
            const uniqueMergedSubscriptions = Array.from(new Set(mergedSubscriptions));

            console.log(uniqueMergedSubscriptions)

            this.allAgencySubscriptions = uniqueMergedSubscriptions
             // Sort the array by date
             this.allAgencySubscriptions.sort((a, b) => {
                return new Date(b.dateCreated) - new Date(a.dateCreated);
              });

            this.overlay = false
            // return result.data
          })
          .catch((err) => {
            this.overlay = false;
          });
      },
      privacyPolicy(url){
        window.open(url, '_blank');
      }
    },
  };
  </script>
  
  <style>
  .v-tabs {
    border-radius: 15px;
  }
  </style>
  